import './pageHero.scss';
import * as React from 'react';
import Measure from 'react-measure';
import { HeaderFadeContext, useHeaderFadeProgress } from '../../hooks/useHeaderFade';
export const PageHero = (props) => {
    const { title, parallax, children, darkenBg } = props;
    const { dispatch: HeaderFadeDispatch } = React.useContext(HeaderFadeContext);
    const headerFadeProgress = useHeaderFadeProgress().progress;
    const parallaxAmount = React.useMemo(() => headerFadeProgress * 100, [headerFadeProgress]);
    return (<Measure onResize={(contentRect) => {
        if (contentRect.entry)
            HeaderFadeDispatch({ type: 'setHeroHeight', payload: contentRect.entry.height });
    }}>
      {({ measureRef }) => (<div className="page-hero-wrapper" ref={measureRef}>
          <div className="hero-children-wrapper" style={{ transform: parallax ? `translateY(${parallaxAmount}px)` : 'none' }}>
            {children}
          </div>
          {darkenBg && <div className="darken-hero" style={{ opacity: headerFadeProgress }}/>}
          {title && (<div className="page-hero-title-wrapper">
              <div className="page-hero-title" style={{ transform: `translateY(${-parallaxAmount}px)` }}>
                <p>{title}</p>
              </div>
            </div>)}
        </div>)}
    </Measure>);
};
PageHero.defaultProps = {
    parallax: true,
    darkenBg: true,
};
export default PageHero;
